import React, {
  Suspense,
  lazy,
  useCallback,
  useEffect,
  useState,
  useMemo,
} from "react";
import Box from "@mui/material/Box";
import { Skeleton } from "@mui/material";
import { useSelector } from "react-redux";
import styles from "./Nurture.module.css";
import rightDIcon from "./Assets/rightdIcon.svg";
import leftDIcon from "./Assets/leftDIcon.svg";
import { useAuthUser } from "react-auth-kit";
import InactiveAccountPopup from "../../../../components/CustomPopupBilling/InactiveAccountPopup";
import NurtureListView from "./NurtureListView";
import { getSubDomainAccessStatus } from "../../../../components/RolePermissionAccess/RolePermissionAccess";
import {
  resetleadConvertionSuccess,
  resetLeadCreateSuccess,
  resetLeadLostSuccess,
  resetLeadUpdateSuccess,
  resetUpdateNoPaymentCollection,
} from "../service/nurtureSlice";
import { useDispatch } from "react-redux";
import AddBatchPopup from "../../Manage/ManageBatch/BatchEditor/AddBatchPopup";
import {
  clearLeadBoardRefresh,
  clearTaskBoardRefresh,
} from "../../../../service/websocketNotificationsSlice";
import { getBatchList } from "../../Manage/ManageBatch/service/Batchslice";
import SearchableCourseList from "./SearchableCourseList";
import { resetDeleteEntitySuccess } from "../../../../service/activeInstituteSlice";
import { getCustomFields } from "../../Settings/service/settingsSlice";
import { getStaffList } from "../../Manage/ManageStaff/service/Staffslice";
import { toggleTriggerForNurture } from "../../Main/service/submerchantBranchUpdationSlice";

const NurtureKanban = lazy(() => import("./NurtureKanban"));
// const SearchableCourseList = lazy(() => import("./SearchableCourseList"));

export default function Nurture(props: any) {
  const {
    GetBranchList,
    GetCourseList,
    GetBatchList,
    GetLeadById,
    GetBatchByInstitute,
    GetBatchById,
    GetDemoByBatchId,
    GetDemoByDateAndBatch,
    GetDemoByEnquiryId,
    GetInboxByLeadId,
    GetCourseById,
    GetInstituteById,
    GetBatchTimeByBatchId,
    GetCourseByCategoryByInstitute,
    GetNurtureLeadBoard,
    GetLeadActivityList,
    GetLeadNoteList,
    GetLeadTaskList,
    GetLeadPaymentList,
    GetLeadListByInstituteAndContact,
    GetDemoCalanderByCourseAndInstitute,
    GetEmiDataOfLead,
    GetAppsByInstitute,
    CreateSource,

    // Api call status
    loading,
    error,
    success,

    leadCreateSuccess,
    leadCreateError,

    leadStatusUpdateSuccess,
    leadStatusUpdateError,
    leadStatusUpdateLoading,

    leadUpdateSuccess,

    leadConvertionSuccess,
    leadConvertionError,

    leadPriorityUpdateSuccess,

    composeEmailSuccess,

    CreateTask,
    createTaskSuccess,
    lastCreatedTaskCategory,

    CreateNote,
    createNoteSuccess,

    CreateDemo,
    createDemoSuccess,

    RecordPayment,
    createPaymentSuccess,

    EditDemo,
    editDemoSuccess,

    leadAssigneeUpdateSuccess,

    leadLostUpdateSuccess,

    nurtureAddEnquiry,
    UpdateLeadSwimlaneStatus,
    UpdateLead,
    CourseConfig,
    leadBoard,
    leadActivityList,
    leadNoteList,
    leadById,
    ConvertLeadToStudent,
    UpdateLeadPriority,
    UpdateLeadAssignee,
    ComposeEmailSent,
    leadInbox,
    leadTaskList,
    leadPaymentList,
    UpdateLeadEnquiyStatus,
    courseDataWithCategory,
    GetAllTasksType,
    handleCompress,
    leadConvertionLoading,
    GetLeadsForBoard,
    onLeadsSuccess,
    onLeadsData,
    leadCreateLoading,
    onLeadsLoading,

    leadListByContact,
    DeleteNote,
    deleteNoteSuccess,
    EditNote,
    editNoteSuccess,
    DeleteTask,
    deleteTaskSuccess,
    lastDeletedTaskCategory,
    EditTask,
    editTaskSuccess,
    UpdateTaskStatus,
    CreateBatch,
    DeleteDemoBookedForLead,
    deleteDemoBookedSuccess,
    leadTasksloading,
    paymentListLoading,
    noteListLoading,
    inboxLoading,
    UpdateLeadEmiDetails,
    leadEmiData,
    SendPaymentLink,
    DownloadPaymentReceipt,
    EditRecordPayment,
    CallLead,
    CallDispositionForm,

    CreateComment,
    DeleteComment,
    EditComment,
    updateNoPaymentCollectedSuccess,
    randomPaymentCollectSuccess,
    sessionPayRecordSuccess,
  } = props;
  const auth = useAuthUser();
  const authUser = auth();
  const dispatch = useDispatch();

  const { userById } = useSelector((state: any) => state.userDetails);
  const { deleteEntitySuccess, deleteEntityError } = useSelector(
    (state: any) => state.activeInstitute,
  );

  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission,
  );

  const hasSelfAssignedLeadOnly = getSubDomainAccessStatus(
    "NURTURE_BOARD",
    "LEAD_ACCESS",
    "ASSIGNED_ONLY",
    userById?.rolePermission,
  );

  const branchList = useSelector((state: any) => state.branch.branchList);
  const courseList = useSelector((state: any) => state.courses.courses);
  const batches = useSelector((state: any) => state.batch.batchList);
  const batchList = useMemo(
    () => batches?.filter((item: any) => item?.status !== "DRAFT"),
    [batches],
  );
  const batchCreateSuccess = useSelector(
    (state: any) => state.batch.batchCreateSuccess,
  );

  const taskTypes = leadBoard?.taskType;

  const { leadUpdateNotify, taskUpdateNotify, taskUpdateNotifyDirect } =
    useSelector((state: any) => state?.websocketNotifications);

  const employees = useSelector((state: any) => state.staff.staffList);
  const courseTypes = useMemo(() => leadBoard?.courseType, [leadBoard]);

  const [selectedCourse, setSelectedCourse] = useState<any>(null);
  const [isKanbanView, setIsKanbanView] = useState<boolean>(true);
  const [nurtureLeadStatus, setNurtureLeadStatus] = useState<any>("ACTIVE");
  const [leadItems, setLeadItems] = useState<any>();
  const [leadListItems, setLeadListItems] = useState<any>();
  const [leadPaginationLoad, setleadPaginationLoad] = useState<boolean>(false);
  const [addBatchModal, setAddBatchModal] = React.useState<boolean>(false);

  const [courseListDrawerOpen, setCourseListDrawerOpen] =
    useState<boolean>(false);
  const [gridAbsolutePosition, setGridAbsolutePosition] =
    useState<boolean>(false);

  const [customFieldsForFilter, setCustomFieldsForFilter] = useState<any>();

  const [checkedAdditionalFilter, setCheckedAdditionalFilter] = useState<any>(
    [],
  );
  const [selectAdditionalFilter, setSelectAdditionalFilter] = useState<any>([]);
  const [radioAdditionalFilter, setRadioAdditionalFilter] = useState<any>([]);
  const [
    filterForCheckedAdditionalFilter,
    setFilterForCheckedAdditionalFilter,
  ] = useState<any>([]);
  const [filterForSelectAdditionalFilter, setFilterForSelectAdditionalFilter] =
    useState<any>([]);
  const [filterForRadioAdditionalFilter, setFilterForRadioAdditionalFilter] =
    useState<any>([]);
  const [sortingOrder, setSortingOrder] = useState("desc");
  const [sortingOrderForLastActivity, setSortingOrderForLastActivity] =
    useState("desc");
  const [defaultIconForLast, setDefaultIconForLast] = useState(true);
  const [defaultIcon, setDefaultIcon] = useState(true);
  const [selectedCourseForMoving, setSelectedCourseForMoving] = useState<any>(
    [],
  );
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [selectedContacts, setSelectedContacts] = useState<string[]>([]);
  const [leftHandSideLoader, setLeftHandSideLoader] = useState(false);
  const [draggedLeadInfo, setDraggedLeadInfo] = useState<any>();

  const instituteFromLocalStorage = JSON.parse(
    localStorage.getItem("ACTIVE_INSTITUTE")!,
  );

  const { customFields } = useSelector((state: any) => state.appSettings);

  useEffect(() => {
    if (instituteFromLocalStorage?.id) {
      dispatch<any>(getCustomFields(instituteFromLocalStorage?.id));
    }
  }, []);

  useEffect(() => {
    if (customFields) {
      const fields = customFields?.fields
        ?.map((field: any) => {
          if (
            field?.field?.fieldType === "radio" ||
            field?.field?.fieldType === "select" ||
            field?.field?.fieldType === "checkbox"
          ) {
            return field?.field;
          }
        })
        ?.filter((d: any) => d !== undefined);
      setCustomFieldsForFilter(fields);
    }
  }, [customFields]);

  const toggleCourseDrawer = useCallback(() => {
    setCourseListDrawerOpen(!courseListDrawerOpen);
    const queryParams = new URLSearchParams(window.location.search);

    if (courseListDrawerOpen) {
      queryParams.delete("courseDrawer");
    } else {
      queryParams.set("courseDrawer", "true");
    }
    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.pushState({}, "", newUrl);
  }, [courseListDrawerOpen]);

  const defaultLeadsCall = useCallback(
    (isListView: boolean, statusType: string, courseId: string) => {
      const userFromLocalStorage = authUser?.institute[0]?.instituteDetails;
      const urlSearchParams = new URLSearchParams(window.location.search);

      const branchParam = urlSearchParams.get("filteredBranches");
      const batchParam = urlSearchParams.get("filteredBatches");
      const assigneeParam = urlSearchParams.get("filteredAssignees");
      const priorityParam = urlSearchParams.get("filteredPriorities");
      const sourceParam = urlSearchParams.get("filteredSources");
      const stagesParam = urlSearchParams.get("filteredStages");
      const tagsParam = urlSearchParams.get("filteredTags");

      const sortingOrderFromUrl: any = urlSearchParams.get("sortingOrder");
      const sortingKey: any = urlSearchParams.get("sortingKey");
      if (sortingKey === "lastAssignedOnDate") {
        setSortingOrder(sortingOrderFromUrl);
        setDefaultIconForLast(true);
        setDefaultIcon(false);
      } else if (sortingKey === "lastActivityDate") {
        setSortingOrderForLastActivity(sortingOrderFromUrl);
        setDefaultIconForLast(false);
        setDefaultIcon(true);
      } else {
        setDefaultIconForLast(true);
        setDefaultIcon(true);
      }
      const prioritiesInUrl = priorityParam
        ? priorityParam.split("|").map((item: string) => item)
        : [];
      const sourcesInUrl = sourceParam
        ? sourceParam
          .split("|")
          .map((item: string) => item?.toUpperCase().replace(/\s+/g, "_"))
        : [];
      const stagesInUrl = stagesParam
        ? stagesParam.split("|").map((item: string) => item)
        : [];
      const assigneeIdInUrl = assigneeParam
        ? assigneeParam.split("|").map((item: string) => item)
        : [];
      const branchIdInUrl = branchParam
        ? branchParam.split("|").map((item: string) => item)
        : [];
      const batchIdInUrl = batchParam
        ? batchParam.split("|").map((item: string) => item)
        : [];

      const tagStatusInUrl = tagsParam
        ? tagsParam.split("|").map((item: string) => ({
          value: item,
        }))
        : [];

      const dynamicChecked: any[] = [];
      const dynamicSelect: any[] = [];
      const dynamicRadio: any[] = [];

      urlSearchParams.forEach((value, key) => {
        const predefinedKeys = [
          "filteredBranches",
          "filteredBatches",
          "filteredAssignees",
          "filteredPriorities",
          "filteredSources",
          "filteredStages",
          "filteredTags",
          "selectedCourse",
          "nurtureLeadStatus",
        ];

        if (!predefinedKeys.includes(key)) {
          const fieldMeta = customFieldsForFilter?.find(
            (f: any) => f.fieldName === key,
          );

          if (fieldMeta) {
            const parsedValue = value.split(",");
            const entry = { key, value: parsedValue };

            if (fieldMeta.fieldType === "checkbox") {
              dynamicChecked.push(entry);
            } else if (fieldMeta.fieldType === "select") {
              dynamicSelect.push(entry);
            } else if (fieldMeta.fieldType === "radio") {
              dynamicRadio.push(entry);
            }
          }
        }
      });

      if (userFromLocalStorage && courseId) {
        type Data = {
          instituteId: string;
          isListView: boolean;
          isFilter: boolean;
          entityName: string;
          courseId: string;
          enquiryStatus: string;
          branchId?: any[];
          enquirySource?: any[];
          enquiryPriority?: any[];
          batchId?: any[];
          assignedToId?: any[];
          enquirySwimlaneStatus?: any[];
          enquiryProfileTag?: any[];
          additionalFilters?: any[];
          sortKey?: string;
          sortType?: string;
          pageSize?: number;
          laneCursors: {};
        };

        const data: Data = {
          instituteId: userFromLocalStorage?.id,
          isFilter: true,
          isListView: isListView,
          entityName: "ENQUIRY",
          enquiryStatus: statusType,
          courseId: courseId,
          additionalFilters: mergeFilters([
            dynamicChecked,
            dynamicSelect,
            dynamicRadio,
          ]),
          sortKey: sortingKey ? sortingKey : "",
          sortType: sortingOrderFromUrl ? sortingOrderFromUrl : "",
          pageSize: 20,
          laneCursors: {},
        };

        if (!hasAllBranchAccess) {
          data.branchId = [authUser?.institute?.[0]?.branchId];
        } else {
          data.branchId = branchIdInUrl?.length > 0 ? branchIdInUrl : [];
        }

        // if (userById?.roleCode === "COURSE_COUNSELOR") {
        // data.assignedToId = [authUser?.institute?.[0]?.id];
        // }
        if (hasSelfAssignedLeadOnly) {
          data.assignedToId = [authUser?.institute?.[0]?.id];
        } else {
          data.assignedToId =
            assigneeIdInUrl?.length > 0 ? assigneeIdInUrl : [];
        }

        if (sourcesInUrl) {
          data.enquirySource = sourcesInUrl?.length > 0 ? sourcesInUrl : [];
        }
        if (prioritiesInUrl) {
          data.enquiryPriority =
            prioritiesInUrl?.length > 0 ? prioritiesInUrl : [];
        }

        if (batchIdInUrl) {
          data.batchId = batchIdInUrl?.length > 0 ? batchIdInUrl : [];
        }

        if (isListView && stagesInUrl) {
          data.enquirySwimlaneStatus =
            stagesInUrl?.length > 0 ? stagesInUrl : [];
        }

        if (tagStatusInUrl) {
          data.enquiryProfileTag =
            tagStatusInUrl?.length > 0
              ? tagStatusInUrl?.map((item: any) =>
                item?.value?.toUpperCase().replace(/\s+/g, "_")
              )
              : [];
        }
        GetLeadsForBoard(data);
      }
    },
    [authUser, customFieldsForFilter],
  );
  const sortingLeadsCall = useCallback(
    (
      isListView: boolean,
      statusType: string,
      courseId: string,
      sortKey?: string,
      sortType?: string,
    ) => {
      const userFromLocalStorage = authUser?.institute[0]?.instituteDetails;
      const urlSearchParams = new URLSearchParams(window.location.search);

      const branchParam = urlSearchParams.get("filteredBranches");
      const batchParam = urlSearchParams.get("filteredBatches");
      const assigneeParam = urlSearchParams.get("filteredAssignees");
      const priorityParam = urlSearchParams.get("filteredPriorities");
      const sourceParam = urlSearchParams.get("filteredSources");
      const stagesParam = urlSearchParams.get("filteredStages");
      const tagsParam = urlSearchParams.get("filteredTags");
      const prioritiesInUrl = priorityParam
        ? priorityParam.split("|").map((item: string) => item)
        : [];
      const sourcesInUrl = sourceParam
        ? sourceParam
          .split("|")
          .map((item: string) => item?.toUpperCase().replace(/\s+/g, "_"))
        : [];
      const stagesInUrl = stagesParam
        ? stagesParam.split("|").map((item: string) => item)
        : [];
      const assigneeIdInUrl = assigneeParam
        ? assigneeParam.split("|").map((item: string) => item)
        : [];
      const branchIdInUrl = branchParam
        ? branchParam.split("|").map((item: string) => item)
        : [];
      const batchIdInUrl = batchParam
        ? batchParam.split("|").map((item: string) => item)
        : [];

      const tagStatusInUrl = tagsParam
        ? tagsParam.split("|").map((item: string) => ({
          value: item,
        }))
        : [];

      const dynamicChecked: any[] = [];
      const dynamicSelect: any[] = [];
      const dynamicRadio: any[] = [];

      urlSearchParams.forEach((value, key) => {
        const predefinedKeys = [
          "filteredBranches",
          "filteredBatches",
          "filteredAssignees",
          "filteredPriorities",
          "filteredSources",
          "filteredStages",
          "filteredTags",
          "selectedCourse",
          "nurtureLeadStatus",
        ];

        if (!predefinedKeys.includes(key)) {
          const fieldMeta = customFieldsForFilter?.find(
            (f: any) => f.fieldName === key,
          );

          if (fieldMeta) {
            const parsedValue = value.split(",");
            const entry = { key, value: parsedValue };

            if (fieldMeta.fieldType === "checkbox") {
              dynamicChecked.push(entry);
            } else if (fieldMeta.fieldType === "select") {
              dynamicSelect.push(entry);
            } else if (fieldMeta.fieldType === "radio") {
              dynamicRadio.push(entry);
            }
          }
        }
      });

      if (userFromLocalStorage && courseId) {
        type Data = {
          instituteId: string;
          isListView: boolean;
          isFilter: boolean;
          entityName: string;
          courseId: string;
          enquiryStatus: string;
          branchId?: any[];
          enquirySource?: any[];
          enquiryPriority?: any[];
          batchId?: any[];
          assignedToId?: any[];
          enquirySwimlaneStatus?: any[];
          enquiryProfileTag?: any[];
          additionalFilters?: any[];
          sortKey?: string;
          sortType?: string;
          pageSize?: number;
          laneCursors: {};
        };

        const data: Data = {
          instituteId: userFromLocalStorage?.id,
          isFilter: true,
          isListView: isListView,
          entityName: "ENQUIRY",
          enquiryStatus: statusType,
          courseId: courseId,
          additionalFilters: mergeFilters([
            dynamicChecked,
            dynamicSelect,
            dynamicRadio,
          ]),
          sortKey: sortKey ? sortKey : "",
          sortType: sortType ? sortType : "",
          pageSize: 20,
          laneCursors: {},
        };

        if (!hasAllBranchAccess) {
          data.branchId = [authUser?.institute?.[0]?.branchId];
        } else {
          data.branchId = branchIdInUrl?.length > 0 ? branchIdInUrl : [];
        }

        if (hasSelfAssignedLeadOnly) {
          data.assignedToId = [authUser?.institute?.[0]?.id];
        } else {
          data.assignedToId =
            assigneeIdInUrl?.length > 0 ? assigneeIdInUrl : [];
        }

        if (sourcesInUrl) {
          data.enquirySource = sourcesInUrl?.length > 0 ? sourcesInUrl : [];
        }
        if (prioritiesInUrl) {
          data.enquiryPriority =
            prioritiesInUrl?.length > 0 ? prioritiesInUrl : [];
        }

        if (batchIdInUrl) {
          data.batchId = batchIdInUrl?.length > 0 ? batchIdInUrl : [];
        }

        if (isListView && stagesInUrl) {
          data.enquirySwimlaneStatus =
            stagesInUrl?.length > 0 ? stagesInUrl : [];
        }

        if (tagStatusInUrl) {
          data.enquiryProfileTag =
            tagStatusInUrl?.length > 0
              ? tagStatusInUrl?.map((item: any) =>
                item?.value?.toUpperCase().replace(/\s+/g, "_")
              )
              : [];
        }
        GetLeadsForBoard(data);
      }
    },
    [authUser, customFieldsForFilter],
  );
  const mergeFilters = (filterGroups: any[][]) => {
    const mergedMap: Record<string, Set<string>> = {};
    filterGroups?.flat()?.forEach(({ key, value }) => {
      if (!mergedMap[key]) {
        mergedMap[key] = new Set(value);
      } else {
        value.forEach((v: string) => mergedMap[key].add(v));
      }
    });

    return Object.entries(mergedMap).map(([key, valSet]) => ({
      key,
      value: Array.from(valSet),
    }));
  };

  const filterLeadsCall = useCallback(
    (
      isListView: boolean,
      statusType: string,
      courseId: string,
      branches: any[],
      enquirySource: any[],
      enquiryPriority: any[],
      batchIds: any[],
      assignedToIds: any[],
      swimlaneStages: any[],
      tags: any,
      checkboxAdditionalParams: any,
      selectAdditionalParams: any,
      radioAdditionalParams: any,
    ) => {
      const userFromLocalStorage = authUser?.institute[0]?.instituteDetails;
      if (userFromLocalStorage && courseId) {
        type Data = {
          instituteId: string;
          isListView: boolean;
          isFilter: boolean;
          entityName: string;
          courseId: string;
          enquiryStatus: string;
          branchId?: any[];
          enquirySource?: any[];
          enquiryPriority?: any[];
          batchId?: any[];
          assignedToId?: any[];
          enquirySwimlaneStatus?: any[];
          enquiryProfileTag?: any[];
          additionalFilters?: any[];
          pageSize?: number;
          laneCursors: {};
        };

        const data: Data = {
          instituteId: userFromLocalStorage?.id,
          isFilter: true,
          isListView: isListView,
          entityName: "ENQUIRY",
          enquiryStatus: statusType,
          courseId: courseId,
          additionalFilters: mergeFilters([
            checkboxAdditionalParams,
            selectAdditionalParams,
            radioAdditionalParams,
          ]),
          pageSize: 20,
          laneCursors: {},
        };

        if (!hasAllBranchAccess) {
          data.branchId = [authUser?.institute?.[0]?.branchId];
        } else {
          data.branchId =
            branches?.length > 0 ? branches?.map((item: any) => item?.id) : [];
        }

        if (hasSelfAssignedLeadOnly) {
          data.assignedToId = [authUser?.institute?.[0]?.id];
        } else {
          data.assignedToId =
            assignedToIds?.length > 0
              ? assignedToIds?.map((item: any) => item?.id)
              : [];
        }

        if (enquirySource) {
          data.enquirySource =
            enquirySource?.length > 0
              ? enquirySource?.map((item: any) =>
                item?.source?.toUpperCase().replace(/\s+/g, "_"),
              )
              : [];
        }

        if (enquiryPriority) {
          data.enquiryPriority =
            enquiryPriority?.length > 0
              ? enquiryPriority?.map((item: any) => item?.priority)
              : [];
        }

        if (batchIds) {
          data.batchId =
            batchIds?.length > 0 ? batchIds?.map((item: any) => item?.id) : [];
        }

        if (isListView && swimlaneStages) {
          data.enquirySwimlaneStatus =
            swimlaneStages?.length > 0
              ? swimlaneStages?.map((item: any) => item?.leadStage)
              : [];
        }

        if (tags) {
          data.enquiryProfileTag =
            tags?.length > 0
              ? tags?.map((item: any) =>
                item?.value?.toUpperCase().replace(/\s+/g, "_")
              )
              : [];
        }

        GetLeadsForBoard(data);
      }
    },
    [],
  );

  const handleSelectedCourse = React.useCallback(
    (course: any) => {
      setSelectedCourse(course);
      setLeadItems("");
      setLeadListItems("");
      setleadPaginationLoad(false);
      // defaultLeadsCall(
      //   isKanbanView ? false : true,
      //   nurtureLeadStatus,
      //   course?.courseId
      // );
      setDefaultIconForLast(true);
      sortingLeadsCall(
        isKanbanView ? false : true,
        nurtureLeadStatus,
        course?.courseId,
        "",
        "",
      );
      setDefaultIcon(true);
      setSelectedCourseForMoving([]);
      setSelectedContacts([]);
      setIsCheckboxChecked(false);
    },
    [
      isKanbanView,
      nurtureLeadStatus,
      setSelectedCourse,
      setleadPaginationLoad,
      defaultLeadsCall,
    ],
  );

  React.useEffect(() => {
    const userFromLocalStorage = authUser?.institute[0]?.instituteDetails;

    if (userFromLocalStorage) {
      let data = {
        branchId: !hasAllBranchAccess ? userById?.branchId : "",
        id: userFromLocalStorage?.id,
        assigneeId: hasSelfAssignedLeadOnly ? authUser?.institute?.[0]?.id : "",
      };

      if (data) {
        GetCourseByCategoryByInstitute(data);
      }
      dispatch<any>(
        getBatchList({
          id: instituteData?.id,
          batchConductType: "ALL",
          loadStudent: true,
          branchId: hasAllBranchAccess ? "" : userById?.branchId,
        }),
      );
      dispatch<any>(resetUpdateNoPaymentCollection());
    }
  }, [userById, updateNoPaymentCollectedSuccess]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const courseDrawer = urlSearchParams.get("courseDrawer");

    if (courseDrawer) {
      setCourseListDrawerOpen(true);
    }
  }, [setCourseListDrawerOpen]);

  useEffect(() => {
    const userFromLocalStorage = authUser?.institute[0]?.instituteDetails;
    const urlSearchParams = new URLSearchParams(window.location.search);
    const nurtureView = urlSearchParams.get("nurtureView");
    const leadStatusParam = urlSearchParams.get("nurtureLeadStatus");
    const selectedCourseinUrl = urlSearchParams.get("selectedCourse");

    if (nurtureView === "LIST") {
      setIsKanbanView(false);
    }

    // Lead type set
    let leadStatusFilter = "ACTIVE";
    if (leadStatusParam === "LOST") {
      leadStatusFilter = "LOST";
      setNurtureLeadStatus("LOST");
    } else {
      setNurtureLeadStatus("ACTIVE");
    }

    // Course set
    let defaultCourse = null;

    if (courseDataWithCategory) {
      const filteredCourses = courseDataWithCategory?.filter(
        (category: any) =>
          category?.courseDetails &&
          category?.courseDetails?.length > 0 &&
          category?.courseCategoryName !== "All Courses",
      );

      if (selectedCourseinUrl && filteredCourses?.length > 0) {
        const filteredCategory = filteredCourses?.find(
          (category: any) =>
            category?.courseDetails &&
            category?.courseDetails?.some(
              (course: any) => course?.courseId === selectedCourseinUrl,
            ),
        );
        if (filteredCategory) {
          const courseFromUrl = filteredCategory?.courseDetails?.find(
            (course: any) => course?.courseId === selectedCourseinUrl,
          );
          if (courseFromUrl) {
            setSelectedCourse(courseFromUrl);
            defaultCourse = courseFromUrl;
            if (courseFromUrl && courseFromUrl?.leadcount > 0) {
              urlSearchParams.set("selectedCourse", courseFromUrl?.courseId);
              const newUrl = `${window.location.pathname
                }?${urlSearchParams.toString()}`;
              window.history.pushState({}, "", newUrl);
            }
          }
        }
      } else if (selectedCourseinUrl === null && filteredCourses?.length > 0) {
        setSelectedCourse(filteredCourses?.[0]?.courseDetails?.[0]);
        defaultCourse = filteredCourses?.[0]?.courseDetails?.[0];
        console.log(filteredCourses);
        urlSearchParams.set(
          "selectedCourse",
          filteredCourses?.[0]?.courseDetails?.[0]?.courseId,
        );
        const newUrl = `${window.location.pathname
          }?${urlSearchParams.toString()}`;
        window.history.pushState({}, "", newUrl);
      }
    }

    if (userFromLocalStorage && defaultCourse) {
      setleadPaginationLoad(false);
    }
  }, [courseDataWithCategory]);

  const [isInitialCall, setIsInitialCall] = useState<boolean>(true);

  useEffect(() => {
    if (isInitialCall && selectedCourse) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const nurtureView = urlSearchParams.get("nurtureView");
      const leadStatusParam = urlSearchParams.get("nurtureLeadStatus");

      defaultLeadsCall(
        nurtureView !== "LIST" ? false : true,
        leadStatusParam === "LOST" ? "LOST" : "ACTIVE",
        selectedCourse.courseId,
      );

      setIsInitialCall(false);
    }
  }, [selectedCourse, isInitialCall]);

  useEffect(() => {
    if (onLeadsData) {
      if (isKanbanView) {
        setLeadItems(onLeadsData);
        setLeadListItems("");
        setleadPaginationLoad(false);
      } else {
        setLeadListItems(onLeadsData);
        setLeftHandSideLoader(false);
        setLeadItems("");
        setleadPaginationLoad(false);
      }
    }
  }, [onLeadsData, isKanbanView]);

  // React.useEffect(() => {
  // if (
  // // leadStatusUpdateSuccess ||
  // // leadCreateSuccess ||
  // leadUpdateSuccess ||
  // // leadConvertionSuccess ||
  // leadPriorityUpdateSuccess ||
  // leadAssigneeUpdateSuccess ||
  // composeEmailSuccess ||
  // // leadLostUpdateSuccess ||
  // createTaskSuccess ||
  // createPaymentSuccess ||
  // createDemoSuccess ||
  // editDemoSuccess ||
  // deleteDemoBookedSuccess ||
  // batchCreateSuccess
  // ) {
  // const userFromLocalStorage = authUser?.institute[0]?.instituteDetails;
  // const urlSearchParams = new URLSearchParams(window.location.search);
  // const nurtureView = urlSearchParams.get("nurtureView");

  // setleadPaginationLoad(false);
  // if (userFromLocalStorage && selectedCourse) {
  // defaultLeadsCall(
  // nurtureView !== "LIST" ? false : true,
  // nurtureLeadStatus,
  // selectedCourse?.courseId
  // );
  // }
  // }
  // }, [
  // // leadStatusUpdateSuccess,
  // // leadCreateSuccess,
  // leadUpdateSuccess,
  // // leadConvertionSuccess,
  // leadPriorityUpdateSuccess,
  // leadAssigneeUpdateSuccess,
  // composeEmailSuccess,
  // // leadLostUpdateSuccess,
  // createTaskSuccess,
  // createPaymentSuccess,
  // GetNurtureLeadBoard,
  // createDemoSuccess,
  // editDemoSuccess,
  // deleteDemoBookedSuccess,
  // batchCreateSuccess,
  // ]);

  const [lastRefreshTime, setLastRefreshTime] = React.useState<number>(0);

  React.useEffect(() => {
    if (leadUpdateNotify === true || taskUpdateNotify === true) {
      const now = Date.now();
      const timeSinceLastRefresh = now - lastRefreshTime;

      const shouldBypassDebounce = taskUpdateNotifyDirect === true;

      if (!shouldBypassDebounce && timeSinceLastRefresh < 1000) {
        return;
      }

      const userFromLocalStorage = authUser?.institute[0]?.instituteDetails;
      const urlSearchParams = new URLSearchParams(window.location.search);
      const nurtureView = urlSearchParams.get("nurtureView");

      setleadPaginationLoad(false);
      if (userFromLocalStorage && selectedCourse) {
        setLastRefreshTime(now);
        defaultLeadsCall(
          nurtureView !== "LIST" ? false : true,
          nurtureLeadStatus,
          selectedCourse?.courseId,
        );
      } else {
      }

      const timeoutId = setTimeout(() => {
        if (leadUpdateNotify) dispatch(clearLeadBoardRefresh());
        if (taskUpdateNotify) dispatch(clearTaskBoardRefresh());
      }, 3000);

      return () => clearTimeout(timeoutId);
    }
  }, [leadUpdateNotify, taskUpdateNotify, taskUpdateNotifyDirect]);

  React.useEffect(() => {
    if (createTaskSuccess !== true && createTaskSuccess !== false) {
      const isGeneralTaskCreated =
        lastCreatedTaskCategory?.toUpperCase() === "GENERAL_TASK";

      if (isGeneralTaskCreated) {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const nurtureView = urlSearchParams.get("nurtureView");
        const userFromLocalStorage = authUser?.institute?.[0]?.instituteDetails;

        const refreshTimeout = setTimeout(() => {
          if (userFromLocalStorage && selectedCourse) {
            setleadPaginationLoad(false);
            defaultLeadsCall(
              nurtureView !== "LIST" ? false : true,
              nurtureLeadStatus,
              selectedCourse?.courseId,
            );
          }
        }, 1500);

        return () => clearTimeout(refreshTimeout);
      }
    }
  }, [
    createTaskSuccess,
    lastCreatedTaskCategory,
    selectedCourse,
    nurtureLeadStatus,
    defaultLeadsCall,
    authUser,
  ]);

  const isTriggeredForNurture = useSelector(
    (state: any) => state.submerchantBranchUpdation.isTriggeredForNurture,
  );

  React.useEffect(() => {
    if (isTriggeredForNurture === true) {
      const userFromLocalStorage = authUser?.institute[0]?.instituteDetails;
      const urlSearchParams = new URLSearchParams(window.location.search);
      const nurtureView = urlSearchParams.get("nurtureView");

      setleadPaginationLoad(false);
      if (userFromLocalStorage && selectedCourse) {
        defaultLeadsCall(
          nurtureView !== "LIST" ? false : true,
          nurtureLeadStatus,
          selectedCourse?.courseId,
        );
      }
      dispatch<any>(toggleTriggerForNurture(false));

      const timeoutId = setTimeout(() => {
        dispatch(clearLeadBoardRefresh());
      }, 3000);

      return () => clearTimeout(timeoutId);
    }
  }, [isTriggeredForNurture]);

  React.useEffect(() => {
    if (
      (leadConvertionSuccess !== true && leadConvertionSuccess !== false) ||
      (createPaymentSuccess !== true && createPaymentSuccess !== false) ||
      (randomPaymentCollectSuccess !== true &&
        randomPaymentCollectSuccess !== false) ||
      (sessionPayRecordSuccess !== true && sessionPayRecordSuccess !== false)
    ) {
      const userFromLocalStorage = authUser?.institute[0]?.instituteDetails;

      if (userFromLocalStorage) {
        GetBatchList({
          id: userFromLocalStorage?.id,
          batchConductType: "REGULAR_BATCH",
          loadStudent: true,
          branchId: hasAllBranchAccess ? "" : userById?.branchId,
        });
      }
      dispatch(resetleadConvertionSuccess());
    }
  }, [
    leadConvertionSuccess,
    createPaymentSuccess,
    randomPaymentCollectSuccess,
    sessionPayRecordSuccess,
  ]);

  React.useEffect(() => {
    if (
      (leadCreateSuccess !== true && leadCreateSuccess !== false) ||
      (leadUpdateSuccess !== true && leadUpdateSuccess !== false) ||
      (leadLostUpdateSuccess !== true && leadLostUpdateSuccess !== false) ||
      (leadConvertionSuccess !== true && leadConvertionSuccess !== false) ||
      (leadStatusUpdateSuccess !== true && leadStatusUpdateSuccess !== false) ||
      (createPaymentSuccess !== true && createPaymentSuccess !== false) ||
      (randomPaymentCollectSuccess !== true &&
        randomPaymentCollectSuccess !== false) ||
      (sessionPayRecordSuccess !== true && sessionPayRecordSuccess !== false)
    ) {
      const urlContainsNurture = window.location.href.includes("Nurture");
      const userFromLocalStorage = authUser?.institute[0]?.instituteDetails;
      if (userFromLocalStorage && urlContainsNurture) {
        let data = {
          branchId: !hasAllBranchAccess
            ? authUser?.institute?.[0]?.branchId
            : "",
          id: userFromLocalStorage.id,
          assigneeId: hasSelfAssignedLeadOnly
            ? authUser?.institute?.[0]?.id
            : "",
        };
        if (data) {
          GetCourseByCategoryByInstitute(data);
        }
      }

      // dispatch(resetLeadCreateSuccess());
      dispatch(resetLeadUpdateSuccess());
      dispatch(resetLeadLostSuccess());
    }
  }, [
    leadCreateSuccess,
    leadLostUpdateSuccess,
    leadUpdateSuccess,
    leadConvertionSuccess,
    leadStatusUpdateSuccess,
    createPaymentSuccess,
    randomPaymentCollectSuccess,
    sessionPayRecordSuccess,
  ]);

  React.useEffect(() => {
    if (deleteEntitySuccess) {
      const urlContainsNurture = window.location.href.includes("Nurture");
      const userFromLocalStorage = authUser?.institute[0]?.instituteDetails;
      if (userFromLocalStorage && urlContainsNurture) {
        let data = {
          branchId: !hasAllBranchAccess
            ? authUser?.institute?.[0]?.branchId
            : "",
          id: userFromLocalStorage.id,
          assigneeId: hasSelfAssignedLeadOnly
            ? authUser?.institute?.[0]?.id
            : "",
        };
        if (data) {
          GetCourseByCategoryByInstitute(data);
        }
      }
      const urlSearchParams = new URLSearchParams(window.location.search);
      const nurtureView = urlSearchParams.get("nurtureView");
      setTimeout(() => {
        defaultLeadsCall(
          nurtureView !== "LIST" ? false : true,
          nurtureLeadStatus,
          selectedCourse?.courseId,
        );
      }, 1000);
    }
  }, [deleteEntitySuccess]);

  useEffect(() => {
    if (deleteEntitySuccess || deleteEntityError) {
      dispatch(resetDeleteEntitySuccess());
    }
  }, [deleteEntitySuccess, deleteEntityError]);

  const cdwidth = 300;
  const isBillingAdmin = authUser?.institute[0]?.isBillingAdmin;
  const instituteData = JSON.parse(localStorage.getItem("ACTIVE_INSTITUTE")!);
  const accountStatus = instituteData?.billingStatus;

  const closeAddBatchPopup = (type: any) => {
    setAddBatchModal(false);
  };

  useEffect(() => {
    if (selectedCourseForMoving?.length > 0) {
      dispatch<any>(
        getStaffList({
          id: authUser?.institute?.[0]?.instituteId,
        }),
      );
    }
  }, [selectedCourseForMoving]);

  return (
    <Box
      sx={{
        overflow: "hidden",
      }}
    >
      <div
        style={{
          height: "100%",
          backgroundColor: "#F5F5F5",
          overflow: "hidden",
          display: "flex",
          position: "relative",
        }}
      >
        <InactiveAccountPopup type={accountStatus} />
        <div
          style={{
            backgroundColor: "#fff",
            transition: ".5s ease-in-out",
            minWidth: courseListDrawerOpen ? cdwidth : "25px",

            position: "relative",
          }}
          onMouseEnter={() => {
            setGridAbsolutePosition(true);
          }}
          onMouseLeave={() => {
            setGridAbsolutePosition(false);
          }}
        >
          <div
            className={styles.courseDrawerWrapper}
            style={{
              transition: ".5s ease-in-out",
              width:
                courseListDrawerOpen || gridAbsolutePosition ? cdwidth : "100%",
              height: "100%",
              position: gridAbsolutePosition ? "absolute" : "relative",
              backgroundColor: "#fff",
              zIndex: "999",
              borderRight: "1px solid rgba(177, 177, 177, 0.3)",
            }}
          >
            <button
              onClick={() => {
                toggleCourseDrawer();
                setGridAbsolutePosition(false);
              }}
              onMouseEnter={() => {
                setGridAbsolutePosition(gridAbsolutePosition ? true : false);
              }}
              className={styles.courseDrawerBtn}
            >
              <img src={courseListDrawerOpen ? rightDIcon : leftDIcon} alt="" />
            </button>
            <div
              className={styles.courseDrawerWrap}
              style={{
                overflow: "hidden",
                transition: ".5s ease-in-out",
                height: "100%",
              }}
            >
              {courseListDrawerOpen || gridAbsolutePosition ? (
                <SearchableCourseList
                  courseList={courseDataWithCategory && courseDataWithCategory}
                  handleSelectedCourse={handleSelectedCourse}
                  selectedCourse={selectedCourse}
                  setSelectedCourse={setSelectedCourse}
                />
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            transition: ".5s ease-in-out",
            width: courseListDrawerOpen
              ? `calc(100% - ${cdwidth}px)`
              : `calc(100% - 25px)`,
            display: "flex",
          }}
        >
          <Suspense
            fallback={
              <Skeleton animation="wave" variant="rounded" height={100} />
            }
          >
            {isKanbanView ? (
              <NurtureKanban
                loading={loading}
                nurtureAddEnquiry={nurtureAddEnquiry}
                branchList={branchList && branchList}
                courseList={courseList && courseList}
                batchList={batchList && batchList}
                swimlaneData={leadItems}
                UpdateLeadSwimlaneStatus={UpdateLeadSwimlaneStatus}
                selectedCourse={selectedCourse}
                employees={employees && employees}
                batchTypes={courseTypes && courseTypes}
                GetLeadListByInstituteAndContact={
                  GetLeadListByInstituteAndContact
                }
                CreateNote={CreateNote}
                CreateTask={CreateTask}
                GetBatchById={GetBatchById}
                ConvertLeadToStudent={ConvertLeadToStudent}
                UpdateLeadPriority={UpdateLeadPriority}
                UpdateLeadAssignee={UpdateLeadAssignee}
                createNoteSuccess={createNoteSuccess}
                createTaskSuccess={createTaskSuccess}
                deleteTaskSuccess={deleteTaskSuccess}
                lastDeletedTaskCategory={lastDeletedTaskCategory}
                leadCreateSuccess={leadCreateSuccess}
                UpdateLeadEnquiyStatus={UpdateLeadEnquiyStatus}
                GetCourseById={GetCourseById}
                courseTypes={courseTypes && courseTypes}
                sourceList={leadBoard && leadBoard.sourceList}
                handleCompress={handleCompress}
                leadConvertionError={leadConvertionError}
                leadStatusUpdateError={leadStatusUpdateError}
                setLeadItems={setLeadItems}
                leadItems={leadItems}
                onLeadsData={onLeadsData}
                leadCreateLoading={leadCreateLoading}
                GetInstituteById={GetInstituteById}
                leadTasksloading={leadTasksloading}
                paymentListLoading={paymentListLoading}
                noteListLoading={noteListLoading}
                inboxLoading={inboxLoading}
                GetEmiDataOfLead={GetEmiDataOfLead}
                leadEmiData={leadEmiData}
                leadCreateError={leadCreateError}
                isKanbanView={isKanbanView}
                setIsKanbanView={setIsKanbanView}
                nurtureLeadStatus={nurtureLeadStatus}
                setNurtureLeadStatus={setNurtureLeadStatus}
                onLeadsLoading={onLeadsLoading}
                GetLeadsForBoard={GetLeadsForBoard}
                defaultLeadsCall={defaultLeadsCall}
                setLeadListItems={setLeadListItems}
                setleadPaginationLoad={setleadPaginationLoad}
                courseDataWithCategory={courseDataWithCategory}
                filterLeadsCall={filterLeadsCall}
                setAddBatchModal={setAddBatchModal}
                leadUpdateSuccess={leadUpdateSuccess}
                leadConvertionSuccess={leadConvertionSuccess}
                leadStatusUpdateSuccess={leadStatusUpdateSuccess}
                customFieldsForFilter={customFieldsForFilter}
                setCustomFieldsForFilter={setCustomFieldsForFilter}
                checkedAdditionalFilter={checkedAdditionalFilter}
                setCheckedAdditionalFilter={setCheckedAdditionalFilter}
                selectAdditionalFilter={selectAdditionalFilter}
                setSelectAdditionalFilter={setSelectAdditionalFilter}
                radioAdditionalFilter={radioAdditionalFilter}
                setRadioAdditionalFilter={setRadioAdditionalFilter}
                filterForCheckedAdditionalFilter={
                  filterForCheckedAdditionalFilter
                }
                setFilterForCheckedAdditionalFilter={
                  setFilterForCheckedAdditionalFilter
                }
                filterForSelectAdditionalFilter={
                  filterForSelectAdditionalFilter
                }
                setFilterForSelectAdditionalFilter={
                  setFilterForSelectAdditionalFilter
                }
                filterForRadioAdditionalFilter={filterForRadioAdditionalFilter}
                setFilterForRadioAdditionalFilter={
                  setFilterForRadioAdditionalFilter
                }
                fromKanban={true}
                defaultIconForLast={defaultIconForLast}
                setDefaultIconForLast={setDefaultIconForLast}
                defaultIcon={defaultIcon}
                setDefaultIcon={setDefaultIcon}
                draggedLeadInfo={draggedLeadInfo}
                setDraggedLeadInfo={setDraggedLeadInfo}
                setSortingOrder={setSortingOrder}
                setSortingOrderForLastActivity={setSortingOrderForLastActivity}
              />
            ) : (
              <NurtureListView
                loading={loading}
                nurtureAddEnquiry={nurtureAddEnquiry}
                branchList={branchList && branchList}
                courseList={courseList && courseList}
                batchList={batchList && batchList}
                UpdateLeadSwimlaneStatus={UpdateLeadSwimlaneStatus}
                selectedCourse={selectedCourse}
                employees={employees && employees}
                batchTypes={courseTypes && courseTypes}
                GetLeadNoteList={GetLeadNoteList}
                GetLeadTaskList={GetLeadTaskList}
                GetLeadListByInstituteAndContact={
                  GetLeadListByInstituteAndContact
                }
                leadNoteList={leadNoteList}
                CreateNote={CreateNote}
                CreateTask={CreateTask}
                GetBatchById={GetBatchById}
                ConvertLeadToStudent={ConvertLeadToStudent}
                createNoteSuccess={createNoteSuccess}
                createTaskSuccess={createTaskSuccess}
                leadTaskList={leadTaskList}
                leadCreateSuccess={leadCreateSuccess}
                UpdateLeadEnquiyStatus={UpdateLeadEnquiyStatus}
                GetCourseById={GetCourseById}
                courseTypes={courseTypes && courseTypes}
                sourceList={leadBoard && leadBoard.sourceList}
                taskTypes={taskTypes}
                handleCompress={handleCompress}
                leadConvertionError={leadConvertionError}
                leadStatusUpdateError={leadStatusUpdateError}
                setLeadItems={setLeadItems}
                leadItems={leadItems}
                onLeadsData={onLeadsData}
                leadCreateLoading={leadCreateLoading}
                DeleteNote={DeleteNote}
                EditNote={EditNote}
                DeleteTask={DeleteTask}
                EditTask={EditTask}
                UpdateTaskStatus={UpdateTaskStatus}
                GetInstituteById={GetInstituteById}
                leadTasksloading={leadTasksloading}
                paymentListLoading={paymentListLoading}
                noteListLoading={noteListLoading}
                inboxLoading={inboxLoading}
                leadEmiData={leadEmiData}
                isKanbanView={isKanbanView}
                setIsKanbanView={setIsKanbanView}
                editTaskSuccess={editTaskSuccess}
                deleteTaskSuccess={deleteTaskSuccess}
                lastDeletedTaskCategory={lastDeletedTaskCategory}
                deleteNoteSuccess={deleteNoteSuccess}
                editNoteSuccess={editNoteSuccess}
                leadCreateError={leadCreateError}
                setNurtureLeadStatus={setNurtureLeadStatus}
                nurtureLeadStatus={nurtureLeadStatus}
                GetLeadsForBoard={GetLeadsForBoard}
                defaultLeadsCall={defaultLeadsCall}
                setLeadListItems={setLeadListItems}
                leadListItems={leadListItems}
                setleadPaginationLoad={setleadPaginationLoad}
                leadPaginationLoad={leadPaginationLoad}
                filterLeadsCall={filterLeadsCall}
                setAddBatchModal={setAddBatchModal}
                leadUpdateSuccess={leadUpdateSuccess}
                leadStatusUpdateSuccess={leadStatusUpdateSuccess}
                customFieldsForFilter={customFieldsForFilter}
                setCustomFieldsForFilter={setCustomFieldsForFilter}
                checkedAdditionalFilter={checkedAdditionalFilter}
                setCheckedAdditionalFilter={setCheckedAdditionalFilter}
                selectAdditionalFilter={selectAdditionalFilter}
                setSelectAdditionalFilter={setSelectAdditionalFilter}
                radioAdditionalFilter={radioAdditionalFilter}
                setRadioAdditionalFilter={setRadioAdditionalFilter}
                filterForCheckedAdditionalFilter={
                  filterForCheckedAdditionalFilter
                }
                setFilterForCheckedAdditionalFilter={
                  setFilterForCheckedAdditionalFilter
                }
                filterForSelectAdditionalFilter={
                  filterForSelectAdditionalFilter
                }
                setFilterForSelectAdditionalFilter={
                  setFilterForSelectAdditionalFilter
                }
                filterForRadioAdditionalFilter={filterForRadioAdditionalFilter}
                setFilterForRadioAdditionalFilter={
                  setFilterForRadioAdditionalFilter
                }
                sortingOrder={sortingOrder}
                setSortingOrder={setSortingOrder}
                sortingLeadsCall={sortingLeadsCall}
                fromKanban={false}
                sortingOrderForLastActivity={sortingOrderForLastActivity}
                setSortingOrderForLastActivity={setSortingOrderForLastActivity}
                defaultIconForLast={defaultIconForLast}
                setDefaultIconForLast={setDefaultIconForLast}
                defaultIcon={defaultIcon}
                setDefaultIcon={setDefaultIcon}
                selectedCourseForMoving={selectedCourseForMoving}
                setSelectedCourseForMoving={setSelectedCourseForMoving}
                isCheckboxChecked={isCheckboxChecked}
                setIsCheckboxChecked={setIsCheckboxChecked}
                selectedContacts={selectedContacts}
                setSelectedContacts={setSelectedContacts}
                leftHandSideLoader={leftHandSideLoader}
                setLeftHandSideLoader={setLeftHandSideLoader}
                draggedLeadInfo={draggedLeadInfo}
                setDraggedLeadInfo={setDraggedLeadInfo}
                hasSelfAssignedLeadOnly={hasSelfAssignedLeadOnly}
                courseListDrawerOpen={courseListDrawerOpen}
              />
            )}
          </Suspense>
        </div>
      </div>
      {addBatchModal && (
        <AddBatchPopup isOpen={addBatchModal} onClose={closeAddBatchPopup} />
      )}
    </Box>
  );
}
